import { usePrefetchTable } from '@/legacy/features/table/hooks/usePrefetchTable';
import { TABLE_IDS } from '@/legacy/constants/tableids';
import urls from '@/legacy/config/env';

export const usePrefetchTagsTable = () =>
	usePrefetchTable({
		pageKey: 'app__users__tags_nfc__overview',
		tableId: TABLE_IDS.TAG_USERS,
		endpoint: urls.tags.tagsTable,
		sortBy: 'money_balance',
	});
